import { h, Fragment } from 'preact'
import { useRef, useEffect, useState } from 'preact/hooks'
import { useSelector } from 'react-redux'
import { getCssVar } from '@utils/dom'
import SearchInput from './SearchInput'
import SearchResults from './SearchResults'
import withProvider from '@state/withProvider'
import { usePrevious } from '@utils/hooks'
import useInitialState from '@core/hooks/useInitialState'

function QuickSearch({ maxProducts, maxCategories, showPictures = false }) {
	const [categories, setCategories] = useState([])
	const [products, setProducts] = useState([])
	const [term, setTerm] = useState('')
	const [loading, setLoading] = useState(false)
	const prevTerm = usePrevious(term)
	const timer = useRef(null)

	// const { productSearchAutoComplete, productSearch } = useSelector(
	//     state => state.routes,
	// )

	const { productSearchAutoComplete, productSearch } = useInitialState(state => state.routes)

	const autoCompleteUrl = term => `${productSearchAutoComplete}?term=${term}`
	const searchPageUrl = term => `${productSearch}?q=${term}`
	const hasResults = categories.length > 0 || products.length > 0

	function handleSearchResults(nextProducts, nextCategories) {
		setProducts(maxProducts ? nextProducts.slice(0, maxProducts) : nextProducts)
		setCategories(maxCategories ? nextCategories.slice(0, maxCategories) : nextCategories)
	}

	function handleViewAllResults() {
		window.location = searchPageUrl(term)
	}

	function handleKeyUp(e) {
		setTerm(e.target.value)

		if (e.keyCode === 13) {
			handleViewAllResults()
		}
	}

	async function fetchSuggestions(nextTerm) {
		try {
			const { products, categories, ...rest } = await fetch(autoCompleteUrl(nextTerm), {
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then(res => res.json())
				.then(data => data)

			if (products || categories) {
				handleSearchResults(products, categories)
			}

			if (!products && !categories) setProducts(Object.values(rest))
		} catch (err) {
			console.warn('Error while fetching suggestions', err)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (term && prevTerm !== term) {
			setLoading(true)
			window.clearTimeout(timer.current)

			timer.current = setTimeout(() => {
				fetchSuggestions(term)
			}, 500)
		}

		if (!term) {
			setProducts([])
			setCategories([])
		}
	}, [term]) // eslint-disable-line

	return (
		<Fragment>
			<SearchInput hasResults={hasResults} loading={loading} onKeyUp={handleKeyUp} />

			<SearchResults
				categories={categories}
				products={products}
				searchTerm={term}
				onViewAllResults={handleViewAllResults}
				showPictures={showPictures}
			/>
		</Fragment>
	)
}

export default withProvider(QuickSearch)
